module.exports = __webpack_public_path__ + "img/40_60.aca829b6.png";